import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
export function useIsFirstRun() {
  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isFirstRun = _React$useState2[0],
      setIsFirstRun = _React$useState2[1];

  React.useEffect(function () {
    /* istanbul ignore else */
    if (isFirstRun) {
      setIsFirstRun(false);
    }
    /**
     * Тут важно сохранить [], так как должно срабатывать только 1 раз при маунте
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  return isFirstRun;
}